import { createSlice } from '@reduxjs/toolkit';
import { IEnvInitialState } from './types';

const SLICE_NAME = 'SCRIPT_SLICE';

const initialState: IEnvInitialState = {
  data: {
    apiUrl: '',
    cognitoClientId: '',
    cognitoUserPoolId: '',
    fileUploadUrl: '',
  },
};

const envSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    envConfigAction: (state, { payload: data }) => {
      state.data = data.data;
    },
  },
});

export default envSlice;
